import { getLevel, useAuth } from '@/contexts/AuthContext';
import { Link } from 'react-router-dom';

export function LimitReachedMessage() {
  const { user } = useAuth();
  const isAnonymous = !user || user.is_anonymous;

  if (isAnonymous) {
    return (
      <div className="mt-4 p-3 text-center text-sm text-telekinesis-text-secondary">
        <span>
          You've used your free tokens.{' '}
          <Link to="/signup" className="text-[#107d40] hover:underline">
            Create an account
          </Link>{' '}
          or{' '}
          <Link to="/signin" className="text-[#107d40] hover:underline">
            sign in
          </Link>{' '}
          to keep building.
        </span>
      </div>
    );
  }

  return (
    <div className="mt-4 p-3 text-center text-sm text-telekinesis-text-secondary">
      <LimitReachedSpan />
    </div>
  );
}

function LimitReachedSpan() {
  const { billing } = useAuth();
  const level = getLevel(billing);

  if (level === 'free') {
    return (
      <span>
        You've used all your tokens.{' '}
        <Link to="/subscription" className="text-[#107d40] hover:underline">
          Upgrade
        </Link>{' '}
        for more, or{' '}
        <Link to="/settings" className="text-[#107d40] hover:underline">
          buy a token pack
        </Link>
        .
      </span>
    );
  }

  return (
    <span>
      You've used all your tokens for this period.{' '}
      <Link to="/settings" className="text-[#107d40] hover:underline">
        Buy more tokens
      </Link>{' '}
      or{' '}
      <Link to="/subscription" className="text-[#107d40] hover:underline">
        upgrade your plan
      </Link>
      .
    </span>
  );
}
